import React from 'react';
import WrappedMaps from './wrappedMaps';
import googleMapConfig from 'config/google_map.config';
import NoApiKeyImg from 'zui/Custom/NoApiKeyImg';

const GoogleMap = (props) => {
	return (
		<div>
			{props.children}
			{googleMapConfig.apiKey ? <WrappedMaps data={props.data} /> : <NoApiKeyImg />}
		</div>
	);
};
export default GoogleMap;
